import {CommandExecutionFailedEvent} from '@scalified-monorepo/shared';

/**
 * Payload of a command failure envelope, delivered on the command's SSE trace
 * subject. The `error` message is server-formatted — the same text the
 * synchronous lane returns in-band — so clients render it like any synchronous
 * error response.
 */
export type CommandFailureEnvelope = CommandExecutionFailedEvent['payload'];

export const isCommandFailureEnvelope = (message: unknown): message is {error?: unknown} =>
  typeof message === 'object' && message !== null;

/** User-facing toast text for a failure envelope, with a generic fallback when the envelope carries no message. */
export const getCommandFailureText = (message: unknown): string => {
  if (isCommandFailureEnvelope(message) && typeof message.error === 'string' && message.error.trim()) {
    return message.error;
  }
  return 'The operation failed. Please try again.';
};
